import { CSSProperties } from '@material-ui/core/styles/withStyles'

export const lineClamp = (lines: number): CSSProperties => ({
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': lines,
  overflow: 'hidden',
})
